module.exports = __webpack_public_path__ + "img/placeholder.0efe55d9.jpg";